<!--
 * @Author: Ximen
 * @Date: 2021-03-23 19:13:59
 * @LastEditors: Ximen
 * @LastEditTime: 2021-04-20 19:36:48
-->
<template>
  <a-card class="box">
    <p class="title">创建商城</p>
    <!-- <a-select class="input-style" v-model:value="params.shopMainGoods"
    size="large" placeholder="请选择你的主营品类">
      <a-select-option v-for="item in shopMainGoodsList" :key="item.code">
        {{item.name}}
      </a-select-option>
    </a-select> -->
    <a-input class="input-style" v-model:value="params.shopName"
    size="large" placeholder="请输入商城名称"/>
    <!-- <a-cascader v-model:value="region"
    style="width: 100%;margin-bottom: 20px;"
    :fieldNames='{label: "regionName", value: "regionId", children: "children"}'
     placeholder="请选择地址"
     size="large" :options="regionsAll" />
    <a-input class="input-style" size="large" placeholder="请填写详细地址"
      v-model:value="params.address">
    </a-input> -->

    <!-- <template #suffix>
      <span class="mapSeach">搜索地图</span>
    </template> -->
    <!-- <div class="map" id="container">
      <baidu-map
          :center="center"
          :zoom="zoom"
          :double-click-zoom="true"
          class="baidu-map-view"
        >
          <bm-marker :position="en_center"  animation="BMAP_ANIMATION_BOUNCE">
          </bm-marker>
          <h6 class="title-box g-cen-cen g-back" @click="routerEnFn">地址定位</h6>
      </baidu-map>
    </div> -->
    <a-button type="primary" class="accept-btn" @click="supplementShop()">创建商城</a-button>
    <p class="agree">
      <a-checkbox v-model:checked="checked">
        <span style="font-size:12px">我已阅读并同意</span>
      </a-checkbox>
      <a style="color:#3281DD" @click="openShopModal()">商城协议</a>
    </p>
  </a-card>
  <a-modal v-model:visible="visible" :footer="null" :title="title">
    <p style="height:600px;overflow:auto;">{{content}}</p>
  </a-modal>
</template>

<script lang='ts'>
import commonApi from '@/api/common';
import { defineComponent } from 'vue';
import jsonApi from '@/api/json';
import { message as $message } from 'ant-design-vue';
import storeArg from '@/untils/storeArg';

export default defineComponent({
  name: 'CreateShop',
  data() {
    return {
      shopMainGoodsList: [],
      regionsAll: [],
      region: '',
      params: {
        shopMainGoods: null,
        shopName: '',
        address: '',
        provinceId: '',
        cityId: '',
        regionId: '',
      },
      center: { lng: 116.487925, lat: 40.002525 },
      zoom: 18,
      visible: false,
      title: '',
      content: '',
      checked: false,
    };
  },
  setup() {
    const error = (str: string) => {
      $message.error(str);
    };
    const success = (str: string) => {
      $message.success(str);
    };
    return {
      error,
      success,
    };
  },
  mounted() {
    this.getJson();
  },
  components: {
  },
  methods: {
    supplementShop() {
      console.log(this.params);
      console.log(this.region);
      if (!this.params.shopName) {
        this.error('请输入商城名称');
        return;
      }
      // if (!this.params.shopMainGoods) {
      //   this.error('请选择你的主营品类');
      //   return;
      // }
      // if (this.region.length < 3) {
      //   this.error('请选择地址');
      //   return;
      // }
      // if (!this.params.address) {
      //   this.error('请输入详细地址');
      //   return;
      // }
      if (!this.checked) {
        this.error('请勾选商城协议');
        return;
      }
      const param = {
        shopName: this.params.shopName,
        // shopMainGoods: this.params.shopMainGoods,
        // provinceId: this.region[0],
        // cityId: this.region[1],
        // regionId: this.region[2],
        // address: this.params.address,
      };
      interface Data{
        data: TString;
        success: boolean;
        message: string;
      }
      console.log(param);
      commonApi.createShop(param).then(async ({ data, success, message }: Data) => {
        if (success) {
          console.log(data);
          const parent = this.$parent as unknown as {[x: string]: Function};
          const store = (this as any).$store;
          store.state.isShowGoBack = true;
          store.state.isNew = 1;
          parent.nextStep(3);
        } else {
          this.error(message);
          console.log(message);
        }
      });
    },
    getJson() {
      jsonApi.shopMainGoods().then((data: Record<string, object>) => {
        Object.keys(data).forEach((key) => {
          this.shopMainGoodsList.push(data[key] as never);
        });
      });
      jsonApi.regionsAll().then((data: Record<string, object>) => {
        this.dealRegions(data);
        console.log(this.regionsAll);
      });
    },
    dealRegions(data: TObject, type?: string) {
      const arr = Object.values(data);
      if (!type) {
        this.regionsAll = arr as never;
      }
      arr.forEach((item: TObject) => {
        const tem = item;
        if (item.children && JSON.stringify(item.children) !== '{}') {
          tem.children = Object.values(item.children);
          this.dealRegions(item.children, 'child');
        } else {
          tem.children = '';
        }
      });
    },
    openShopModal() {
      this.title = '商城协议';
      this.content = storeArg;
      this.visible = true;
    },
  },
});
</script>
<style lang="stylus" scoped>
    .box
      margin 128px auto
      border-radius 20px
      width 420px
      .title
        font-size 24px
        color #073D7D
        margin-bottom 40px
      .input-style
        width 100%
        margin-bottom 20px
      .mapSeach
        color #3281DD
      .accept-btn
        width 100%
        height 50px
        margin-top 10px
        border-radius 5px
        background #3281DD
        margin-bottom 18px
        margin-top 30px
      .map
        width 100%
        height 180px
        border 1px solid #D5D5D5
      .agree
        font-size 12px
        text-align left
</style>
